import React, { FC } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { renderRequiredMark, rules } from 'common/helpers/form.helper';
import { IFormValue } from 'common/models';
import { ICreateUserAssigneePayload } from 'entities/User/User.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (payload: ICreateUserAssigneePayload) => void;
}

export const CreateUserAssigneeModal: FC<IComponentProps> = ({ open, loading, onCancel, onSubmit }) => {
  const [form] = useForm();

  const handleCancel = () => {
    if (loading) {
      return;
    }

    onCancel();
    form.resetFields();
  };

  const handleSubmit = ({ name }: IFormValue) => {
    onSubmit({
      name,
      onSuccess: handleCancel,
    });
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      // @ts-ignore
      styles={{ mask: { zIndex: 1002 }, wrapper: { zIndex: 1003 } }}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          Отмена
        </Button>,
        <Button key="save" className="button-sm primary" loading={loading} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <div className="ff-medium fs-m mt-6 mb-3">Добавить сотрудника</div>

      <div className="ff-regular fs-xs color-dark-grey mb-6">
        Для добавления сотрудника в систему обратитесь к администратору.
      </div>

      <Form layout="vertical" requiredMark={renderRequiredMark} form={form} onFinish={handleSubmit}>
        <Form.Item label="ФИО" name="name" rules={[rules.required()]}>
          <Input placeholder="Введите ФИО сотрудника" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
